import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Badge } from 'react-bootstrap';

import { sortTableDateFechaInicio, sortTableDateFechaFin, sortTableStatusStatus } from '../../utils/generalFunctions';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { buscarAsesorias, filtrarAsesorias } from '../../actions/asesorias';

import FiltrosAsesorias from './FiltrosAsesorias';
import EliminarAsesoria from './EliminarAsesoria';

const Asesorias = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Asesorías',
            path: '/asesorias'
        }
    ];

    const dispatch =  useDispatch();

    const { usuario, empresa } = useSelector(state => state.auth);
    const { listado } = useSelector(state => state.asesorias);

    const perfilEmpresaCompleto = !!(empresa?.nombre_comercial && empresa?.rfc);

    const [asesorias, setAsesorias] = useState([]);

    const [asesoriaEliminar, setAsesoriaEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Asesor',
            sortable: true, 
            selector: row => row.asesor?.nombre_completo || 'Sin definir', 
            wrap: true,
            grow: 1.5
        },
        {
            name: 'Motivo',
            sortable: true, 
            selector: row => row.motivo || '-', 
            wrap: true,
            grow: 2
        },
        {
            name: 'Fecha de inicio',
            sortable: true, 
            sortFunction: sortTableDateFechaInicio, 
            cell: item => item.creacion ? new Date(item.creacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir', 
            grow: 1.5
        },
        {
            name: 'Fecha de finalización',
            sortable: true, 
            sortFunction: sortTableDateFechaFin, 
            cell: item => item.finalizacion ? new Date(item.finalizacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir', 
            grow: 1.5
        },
        {
            name: 'Estado',
            sortable: true,
            sortFunction: sortTableStatusStatus, 
            selector: row => {
                switch(row.status){
                    case 0:
                        return(
                            <h6><Badge pill bg="warning">En curso</Badge></h6>
                        )
                    case 1:
                        return(
                            <h6><Badge pill bg="success">Finalizada</Badge></h6>
                        )
                    default:
                        break;
                }
            }
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.asesorias?.eliminar && row.status == 0 &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarAsesoria(row)}><i className="fas fa-trash text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.editar && row.status == 0 &&
                                <Link className="btn btn-sm btn-link px-2 float-end" to={`/asesorias/editar/${row._id}`}><i className="fas fa-edit text-warning"></i></Link>
                        }
                        {
                            usuario?.permisos?.asesorias?.detalles &&
                                <Link className="btn btn-sm btn-link px-2 float-end" to={`/asesorias/detalles/${row._id}`}><i className="fas fa-circle-info text-info"></i></Link>
                        }
                    </div>
                )
            }
        }
    ];

    /* Filtros de busqueda */
    const handleFiltrosBusqueda = () => {
        dispatch(filtrarAsesorias(true));
    }

    /* Eliminar asesoria */
    const handleEliminarAsesoria = (asesoria) => {
        setAsesoriaEliminar(asesoria);
    }

    useEffect(() => {
        dispatch(buscarAsesorias({
            cliente: null,
            status: [0, 1], 
            fecha_inicio: null, 
            fecha_fin: null
        }));
    }, []);

    useEffect(() => {
        setAsesorias(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <FiltrosAsesorias />
            <EliminarAsesoria asesoria={asesoriaEliminar} reestablecerAsesoria={handleEliminarAsesoria} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="title-section my-5">Asesorías</h3>        

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary me-2" onClick={() => handleFiltrosBusqueda()}>Filtros de búsqueda</button>

                        {
                            usuario?.permisos?.asesorias?.agregar && (
                                perfilEmpresaCompleto
                                    ? <Link to="/asesorias/nueva">
                                        <button className="btn btn-primary">Agregar asesoría</button>
                                      </Link>
                                    : <button
                                        className="btn btn-primary"
                                        disabled
                                        title="Completa tu perfil empresarial para crear asesorías"
                                      >
                                        Agregar asesoría
                                      </button>
                            )
                        }
                    </div>            

                    <div className="mt-3">
                        <DataTable
                            columns={columns}
                            data={asesorias}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                            noDataComponent="Aún no hay registros"
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Asesorias;